function Footer() {
  return (
    <footer className="footer">
      <p>
        © 2026 DevSeekr. All rights reserved.
      </p>

      <hr />

      <p>
        Built for developers by Tarigopula Sai
        Shashanth.
      </p>
    </footer>
  );
}

export default Footer;